export default __webpack_public_path__ + "static/media/Snd_N_Starts.8214d09e.mp3";